import React, {  } from 'react';
import Solr from './components/Solr';
import { InventoryProvider } from './providers/InventoryProvider';

export default function InventoryContainer() {
  return (
    <InventoryProvider>
      <Solr />
    </InventoryProvider>
  );
}
